import bem from 'utils/bem';

export const block = bem('verify-email-modal');
